var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-dialog",
    {
      ref: "modal",
      attrs: {
        name: _vm.modalName,
        "modal-props": _vm.sumModalProps,
        title: _vm.title,
      },
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "wrapper" },
          [
            _c("span", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.$t("mute-time"))),
            ]),
            _c("custom-radio", {
              staticClass: "custom-radio",
              attrs: {
                value_change: _vm.hours,
                inputs: _vm.inputs,
                default_data: _vm.hours,
              },
              on: {
                "update:value_change": function ($event) {
                  _vm.hours = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "btn poll-button-cancel", on: { click: _vm.close } },
          [_vm._v(_vm._s(_vm.$t("cancel")))]
        ),
        _c(
          "div",
          { staticClass: "btn poll-button-add", on: { click: _vm.doMute } },
          [_vm._v(_vm._s(_vm.$t("apply")))]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }